import { FC } from 'react'
import { Box, Skeleton } from '@mui/material'

export const ON_DARK_SX = { bgcolor: 'rgba(255, 255, 255, 0.1)' }
export const SURFACE_COLOR = 'rgba(255, 255, 255, 0.05)'

export const SURFACE_SX = {
  bgcolor: SURFACE_COLOR,
  border: '1px solid rgba(255, 255, 255, 0.08)',
  backdropFilter: 'blur(8px)',
}

export const FilterBarSkeleton: FC<{ count?: number }> = ({ count = 5 }) => (
  <Box
    display="flex"
    justifyContent="center"
    gap={2}
    p={1}
    width="100%"
    overflow="hidden"
    borderRadius="0.75rem"
    sx={SURFACE_SX}
  >
    {Array.from({ length: count }).map((_, i) => (
      <Box
        key={i}
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="0.25rem"
        px="0.5rem"
        py="0.375rem"
        flexShrink={0}
      >
        <Skeleton variant="circular" width="2.25rem" height="2.25rem" sx={ON_DARK_SX} />
        <Skeleton width={40} height={16} sx={ON_DARK_SX} />
      </Box>
    ))}
  </Box>
)
